
export const initialValuesExperienciaProfesionalModel = {
  nombre: "",
  dia_inicio: "",
  mes_inicio: "",
  anio_inicio: "",
  fecha_inicio: "",
  dia_terminacion: "",
  mes_terminacion: "",
  anio_terminacion: "",
  fecha_terminacion: "",
  cargo: "",
  funciones: "",
  documento: ""
};
  
  
export interface ExperienciaProfesionalModel {
  nombre: string,  
  dia_inicio: string,
  mes_inicio: string,
  anio_inicio: string,
  fecha_inicio: string,
  dia_terminacion: string,
  mes_terminacion: string,
  anio_terminacion: string,
  fecha_terminacion: string,
  cargo: string
  funciones: string,
  documento: string,
}


  